export const setAcceptanceState = (payload) => { 
    return {
        type:'SET_ACCEPTANCE_STATE',
        payload
    }
}